import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth-guard-guard';
import { environment } from 'environments/environment';



export const routes: Routes = [

  {
    path: 'layout',
    loadChildren: () => import('./layout/layout.routes').then(m => m.routes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'coming-soon/:type',
    loadComponent: () =>
      import('./core/pages/coming-soon/coming-soon')
        .then(m => m.ComingSoon)
  },
  {
    path: '',
    redirectTo: 'layout',
    pathMatch: 'full',
    // data: { guestOnly: false },
  },
  {
    // 👇 Catch unknown urls and redirect to correct place
    path: '**',
    redirectTo: environment.site === 'admin' ? '/auth/admin-login' : '/layout/home'
  }
];
